module.exports = __webpack_public_path__ + "static/media/ic-webhook.fb5c8a22.svg";